import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { MdSignLanguage } from "react-icons/md";
import { useState } from 'react';
import { HiOutlineUpload } from 'react-icons/hi';
import DocumentUploadModal from './Modals/DocumentUploadModal';
import MessageModal from './Modals/MessageModal';
import { BiMessageAdd } from 'react-icons/bi';
import useTheme from '../hooks/useTheme';
import { FaSignOutAlt } from "react-icons/fa";
import { IoIosWarning } from "react-icons/io";
import { Tooltip } from 'react-tooltip';

function Button({ onClick, label, variant, accountID, handleModalClose }) {

  const { t, i18n } = useTranslation();

  useTheme(true);

  // const handleLanguageToggle = () => {
  //   const newLang = i18n.language === 'en' ? 'fr' : 'en';
  //   i18n.changeLanguage(newLang);
  // };

  const handleLanguageToggle = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
    
    // Update URL with the new language parameter
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('lang', newLang);
      
      // Use history API to update URL without reloading the page
      window.history.pushState({}, '', url.toString());
    } catch (error) {
      console.error('Error updating URL with language parameter:', error);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDocAvailable, setIsDocAvailable] = useState(false);
   

  const docUploadAvailability = () => {
    return true
  }

  const openModal = () => {
    const isAvailable = docUploadAvailability();
    if (isAvailable) {
      setIsModalOpen(true);
    } else {
      setIsDocAvailable(true)
    }
  };

  const closeModal = () => {
    const tooltips = document.querySelectorAll('[role="tooltip"]');
    tooltips.forEach(tooltip => tooltip.remove());

    setIsModalOpen(false);
    setIsDocAvailable(false);
    if (handleModalClose) {
      handleModalClose();
    }
  };


  if(variant==="tile"){
    return (
      <button className="themeButton w-32 md:w-56 h-44 flex justify-center items-center overflow-hidden whitespace-normal" onClick={onClick}>
        {label}
      </button>
    )
  }

  if(variant==="lang"){
    return (
      <button className="themeButton flex justify-center items-center gap-2" onClick={handleLanguageToggle} style={{ color: 'var(--nav-text-color)' }}>
        <MdSignLanguage/>{label}
      </button>
    )
  }

  if(variant==="search"){
    return (
      <button className="themeButton w-full flex justify-center items-center gap-2" onClick={onClick}>
        {label}
      </button>
    )
  }

  if(variant==="docUpload"){
    return (
      <>
        <button onClick={openModal} className="rounded-full bg-green-500 hover:bg-green-700 p-2 text-white" data-tooltip-id="upload-tooltip" data-tooltip-content={t('uploadDocs.tooltipContent')}> {/* {t('uploadDocs.tooltipContent')} */}
          <HiOutlineUpload />
        </button>
        <Tooltip id="upload-tooltip" place="left" effect="solid" />
        {isModalOpen && (
            <DocumentUploadModal accountID={accountID} isOpen={isModalOpen} onClose={closeModal} />
        )}
        {isDocAvailable && (
          <div
            onClick={closeModal}
            className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
          >
            <div className="relative bg-white rounded-lg shadow-lg p-6 max-w-sm mx-auto">
              <h2 className="text-lg font-semibold flex justify-center items-center mb-4"><IoIosWarning size={36} className='text-red-500 animate-bounce' /></h2>
              <h4 className='text-center text-xl font-bold my-2'>Sorry!</h4>
              <p className="text-center text-gray-700">  
                Document upload not available now</p>
              <div className="mt-6 flex justify-center">
                <button
                  onClick={closeModal}
                  className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }

  if(variant==="msg"){
    return (
      <>
        <button onClick={openModal} className="rounded-full bg-blue-500 hover:bg-blue-700 p-2 text-white">
          <BiMessageAdd/>
        </button>
        {isModalOpen && (
            <MessageModal isOpen={isModalOpen} onClose={closeModal} />
        )}
      </>
    )
  }

  if(variant==="logout"){
    return (
      <button className="themeButton w-full flex justify-center items-center gap-2 bg-red-500-" onClick={onClick}>
        <FaSignOutAlt/> {label}
      </button>
    )
  }

  if(variant==="reply"){
    return (
      <>
        <button onClick={openModal} className="rounded-full bg-blue-500 hover:bg-blue-700 p-2 px-5 text-white">
          {label}
        </button>
        {isModalOpen && (
            <MessageModal reply={true} isOpen={isModalOpen} onClose={closeModal} />
        )}
      </>
    )
  }

  if(variant==="tabs"){
    return (
      <button className={`${label} tabs w-full text-black bg-transparent flex justify-center items-center gap-2`} onClick={onClick}>
        {label}
      </button>
    )
  }
  
  if(variant==="block"){
    return (
      <button className="themeButton w-full" onClick={onClick}>
        {label}
      </button>
    )
  }

  if(variant==="secondary"){
    return (
      <button className="themeButton w-full bg-red-500 text-white" onClick={onClick}>
        {label}
      </button>
    )
  }

  return (
    <button className="themeButton" onClick={onClick}>
      {label}
    </button>
  );
}

Button.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  variant: PropTypes.string,
  accountID: PropTypes.string,
  handleModalClose: PropTypes.func,
};

export default Button;